import LoginActionHandlerBase from './action_handler_base';
import {SYSTEM_EVENTS} from '../../../events/events';
import Event from '../../../utils/event';
import {Check} from "@sparkware/app-utils";

export default class SubmitActionHandler extends LoginActionHandlerBase {
    static CLASS = 'SubmitActionHandler';

    actionName() {
        return 'onsubmit';
    }

    execute(params) {


        if(Check.isObject(params) && Check.isEmpty(params)){
            const fitToPlayModeEnabled = this.serviceFactory.regulationService().fitToPlayModeEnabled();

            if(fitToPlayModeEnabled){
                Event.fire(SYSTEM_EVENTS.TOUCH_ID_AUTO_LOGIN, { fitToPlaySubmit: true });
                this.serviceFactory.webLoginService().closeLoginForm();

                return Promise.resolve();
            }
        }

        return this.serviceFactory.oAuth2Service().login({
            authenticationdata: JSON.stringify(params.authenticationdata),
            remember_me: params.isremembermerequest
        })
        .then(() => {
            this.serviceFactory.webLoginService().closeLoginForm();
            if(params.isremembermerequest) {
                Event.fire(SYSTEM_EVENTS.ANALYTIC_TRIGGER_ACTIVATED, {category: 'Client_LoginPopup', action: 'RememberMe'});
            }
        })
        .catch(err => {
            this.logger.error('SubmitActionHandler.execute failed', err);
            this.serviceFactory.webLoginService().processLoginResponse(err);
        });
    }
}